import React, { useRef } from "react";
import styled from "styled-components";
import { CalendarWhite } from "../../assets/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Calendar/datepicker.css";
import { Colors } from "../../ColorConstants";

const ReservationCalendarPicker = ({ onSetDate, date }) => {
  const datepickerRef = useRef(null);
  return (
    <Styledcalendar>
      <DateDiv>
        <StyledDatePicker
          // minDate={new Date()}
          selected={date}
          readonly
          value={date}
          onSelect={(date) => onSetDate(date)}
          placeholderText="yyyy-mm-dd"
          ref={datepickerRef}
          dateFormat="MM/yyyy"
          popperModifiers={{
            offset: {
              enabled: true,
              offset: "0, 10px",
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
              boundariesElement: "viewport",
            },
          }}
        />
        <CalendarIcon
          src={CalendarWhite}
          onClick={() => datepickerRef.current.setOpen(true)}
          inputMode="none"
        />
      </DateDiv>
    </Styledcalendar>
  );
};
export const ReservationMonthCalendar = ({ onSetDate, date }) => {
  const datepickerRef = useRef(null);

  const renderMonthContent = (month, shortMonth, longMonth) => {
    const tooltipText = `Tooltip for month: ${longMonth}`;
    return <MonthText title={tooltipText}>{shortMonth}</MonthText>;
  };

  return (
    
    <Styledcalendar>
      <DateDiv>
        <StyledDatePicker
          readonly
          value={date}
          onSelect={(date) => onSetDate(date)}
          ref={datepickerRef}
          selected={date}
          renderMonthContent={renderMonthContent}
          showMonthYearPicker
          dateFormat="MMM yyyy"
        />
        <CalendarIcon
          src={CalendarWhite}
          onClick={() => datepickerRef.current.setOpen(true)}
          inputMode="none"
        />
      </DateDiv>
    </Styledcalendar>
  );
};

export default ReservationCalendarPicker;

const Styledcalendar = styled.div`
  cursor: pointer;
`;

const DateDiv = styled.div`
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  border-radius: 10px;
  width: 250px;
  height: 36px;
  color: ${Colors.white};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${Colors.darkishBlue};
  padding: 8px 8px 4px 12px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 135px
  }
`;

const StyledDatePicker = styled(DatePicker)`
  border: none;
  height: 2rem;
  width: 100%;
  outline: none;
  background: none;
  color: ${Colors.white};
  font-size: 12px;
  font-style: normal;

  &::placeholder {
    color: ${Colors.white};
    font-weight: 500;
  }

`;

const CalendarIcon = styled.img`
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
`;
const MonthText = styled.span`
  display: flex;
  justify-content: center;
  padding: 0.3rem;
  @media (max-width: 414px) {
    padding: 0.1rem 0;
  }
`;
